import { Button } from "@lawline/ui/components/button";
import { cn } from "@lawline/ui/core/cn";
import { useTranslations } from "use-intl";

import { RANGE_OPTIONS } from "../usage.constants";
import type { UsageRange } from "../usage.types";

interface UsageRangeTabsProps {
	value: UsageRange;
	onChange: (range: UsageRange) => void;
}

export function UsageRangeTabs({ value, onChange }: UsageRangeTabsProps) {
	const t = useTranslations("usage.ranges");

	return (
		<div className="bg-muted/40 inline-flex items-center rounded-lg border p-0.5">
			{RANGE_OPTIONS.map((opt) => (
				<Button
					key={opt.value}
					type="button"
					variant={value === opt.value ? "secondary" : "ghost"}
					size="xs"
					className={cn(
						"h-7 px-3 text-xs font-medium",
						value === opt.value ? "shadow-sm" : "text-muted-foreground hover:text-foreground",
					)}
					onClick={() => onChange(opt.value)}
				>
					{t(opt.labelKey)}
				</Button>
			))}
		</div>
	);
}
